import { render, staticRenderFns } from "./PlotsList.vue?vue&type=template&id=08f1fe6c&"
import script from "./PlotsList.vue?vue&type=script&lang=js&"
export * from "./PlotsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports